import { render, staticRenderFns } from "./LocationGeoJson.vue?vue&type=template&id=6072c58a&"
import script from "./LocationGeoJson.vue?vue&type=script&lang=js&"
export * from "./LocationGeoJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports